exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button i.left[data-v-20ea5275]{-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}button i.right[data-v-20ea5275]{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}button:hover i[data-v-20ea5275],button:focus i[data-v-20ea5275]{color:#CFCFCF}.back-btn[data-v-20ea5275]{vertical-align:middle;line-height:26px;color:#000}\n", ""]);

// exports
